import {Card, Stack, css, styled} from '@mui/material';
import {StyledCardProps} from './types';

const StyledCard = styled(Card)<StyledCardProps>`
	padding: 16px;
	border-radius: 8px;
	border: 1px solid transparent;
	cursor: pointer;

	${({$isSelected, theme}) =>
		$isSelected &&
		css`
			border-color: ${theme.palette.success.main};
		`}
`;

const StyledStack = styled(Stack)`
	flex-direction: row;
	gap: 8px;
	align-items: center;
`;

export {StyledCard, StyledStack};
